function mardownToText(node) {
    if (typeof node === 'string') {
        return node;
    }
    if (!node?.props?.children) {
        return "";
    }
    const children = node.props.children;
    if (typeof children === 'string') {
        return children;
    }
    if (Array.isArray(children)) {
        return  children
            .map((child) => {
                return mardownToText(child)
            })
            .join(' ');
    } else {
        return mardownToText(children);
    }
}

export default mardownToText;